import { render, staticRenderFns } from "./VeJwCjBukaoList.vue?vue&type=template&id=5304967f&scoped=true"
import script from "./VeJwCjBukaoList.vue?vue&type=script&lang=js"
export * from "./VeJwCjBukaoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5304967f",
  null
  
)

export default component.exports